<script lang="ts">
	let {
		name,
		label,
		options,
		value = $bindable([])
	}: {
		name: string;
		label?: string;
		options: {
			value: string;
			label: string;
			required?: boolean;
			selected?: boolean;
		}[];
		value?: string[];
	} = $props();
</script>

<div class="input">
	<span class="label">{label}</span>
	{#each options as option}
		<label class="checkbox">
			<input
				type="checkbox"
				class="input:checkbox"
				{name}
				value={option.value}
				required={option.required}
				onchange={(e) => {
					if (e.currentTarget.checked) {
						value = [...value.filter((v) => v !== option.value), option.value];
					} else {
						value = value.filter((v) => v !== option.value);
					}
				}}
			/>
			<span>{option.label}</span>
		</label>
	{/each}
</div>

<style lang="scss">
	.input {
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: $gap2 $gap5;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.label {
		width: 100%;
	}

	.checkbox {
		display: flex;
		flex-direction: row;
		gap: $gap2;
	}
</style>
